{
  "appName": "Osvitly",
  "tagline": "The school platform for teaching and learning",
  "loading": "Loading…",
  "save": "Save",
  "cancel": "Cancel",
  "continue": "Continue",
  "back": "Back",
  "close": "Close",
  "language": "Language",
  "languages": {
    "en": "English",
    "uk": "Українська"
  },
  "theme": {
    "label": "Theme",
    "light": "Light",
    "dark": "Dark",
    "system": "System"
  },
  "roles": {
    "admin": "Administrator",
    "teacher": "Teacher",
    "pupil": "Pupil",
    "parent": "Parent"
  },
  "notFound": {
    "title": "Page not found",
    "description": "The page you're looking for doesn't exist or has moved.",
    "backHome": "Back to dashboard"
  },
  "permissionDenied": {
    "title": "No access",
    "description": "You don't have permission to view this page."
  },
  "actions": "Actions",
  "pagination": {
    "showing": "{{from}}–{{to}} of {{count}}",
    "previous": "Previous page",
    "next": "Next page"
  },
  "footer": "© {{year}} Osvitly. All rights reserved.",
  "openMenu": "Open navigation menu",
  "navigation": "Navigation",
  "showSidebar": "Show sidebar",
  "hideSidebar": "Hide sidebar",
  "password": {
    "show": "Show password",
    "hide": "Hide password"
  }
}
